export default {
    mergeObjects(to, from, opcoes) {
        opcoes = opcoes || {};
        
        if (to?.constructor?.name != 'Object')
            to = {};

        let keys1 = Object.keys(to);

        //pega as keys do objeto
        let keys2 = Object.keys(from);
        keys2.forEach(k => {

            if (!keys1.includes(k) && !opcoes.fullMerge)
                return;

            //variavel interna (começando com _)
            if (k[0] == '_')
                return;

            if (from[k] == undefined) {
                to[k] = from[k];
                return;
            }

            let tipo = (from[k]).constructor.name;

            //se for funcao, ignora
            if (tipo == 'Function')
                return;

            //se for objeto, faz recursivo
            if (tipo == 'Object') {
                if (to[k] == undefined && !!opcoes.substituirVazios)
                    to[k] = from[k]
                else
                    this.mergeObjects(to[k], from[k], opcoes);
                return;
            }

            //outros valores ok
            to[k] = from[k];
        });
    }
}


// export default {
//     mergeObjects(o, o1, o2) {
//         if (!(o instanceof Object)) o = {};

//         copy(o, o1);
//         if (o2)
//             copy(o, o2)

//         function isObject(obj) {
//             var type = Object.prototype.toString.call(obj);
//             return obj === Object(obj) && type != '[object Array]' && type != '[object Function]';
//         };

//         function copy(a, b) {
//             // copy o2 to o
//             for (var key in b)
//                 if (b.hasOwnProperty(key)) {
//                     if (isObject(b[key])) {
//                         if (!isObject(a[key]))
//                             a[key] = Object.assign({}, b[key]);
//                         else copy(a[key], b[key])
//                     } else
//                         a[key] = b[key];
//                 }
//         }

//         return o;
//     }
// };